// 避免脚本冲突：先检查是否已定义
        if (!customElements.get('count-down')) {
            class CountDown extends HTMLElement {
                constructor() {
                    super();
                    this.endDate = this.getAttribute('data-timer');
                    this.daysEl = null;
                    this.hoursEl = null;
                    this.minutesEl = null;
                    this.secondsEl = null;
                    this.previousValues = { days: null, hours: null, minutes: null, seconds: null };
                    this.interval = null;
                }

                connectedCallback() {
                    // 确保元素完全加载后再赋值
                    setTimeout(() => {
                        this.daysEl = this.querySelector('[data-value="days"] .countdown-number');
                        this.hoursEl = this.querySelector('[data-value="hours"] .countdown-number');
                        this.minutesEl = this.querySelector('[data-value="minutes"] .countdown-number');
                        this.secondsEl = this.querySelector('[data-value="seconds"] .countdown-number');

                        if (!this.daysEl || !this.hoursEl || !this.minutesEl || !this.secondsEl) {
                            console.error('倒计时元素查找失败');
                            return;
                        }

                        const parsedEndDate = this.parseDate(this.endDate);
                        if (!parsedEndDate) {
                            console.error('日期格式错误');
                            this.setAllToZero();
                            return;
                        }
                        this.endDateObj = parsedEndDate;

                        // 强制初始更新（解决首次赋值失败）
                        this.updateCountdown(true);
                        this.interval = setInterval(() => this.updateCountdown(), 1000);
                    }, 100);
                }

                disconnectedCallback() {
                    if (this.interval) clearInterval(this.interval);
                }

                parseDate(dateStr) {
                    const cleanedStr = dateStr.replace(/-/g, '/');
                    const date = new Date(cleanedStr);
                    return isNaN(date.getTime()) ? null : date;
                }

                getNewYorkTime() {
                    try {
                        const nyTimeString = new Date().toLocaleString('en-US', {
                            timeZone: 'America/New_York',
                            year: 'numeric', month: '2-digit', day: '2-digit',
                            hour: '2-digit', minute: '2-digit', second: '2-digit',
                            hour12: false
                        });
                        const [datePart, timePart] = nyTimeString.split(', ');
                        const [month, day, year] = datePart.split('/').map(Number);
                        const [hours, minutes, seconds] = timePart.split(':').map(Number);
                        return new Date(year, month - 1, day, hours, minutes, seconds);
                    } catch (e) {
                        console.error('纽约时间获取失败，使用本地时间备用', e);
                        return new Date();
                    }
                }

                setAllToZero() {
                    this.daysEl.textContent = '0';
                    this.hoursEl.textContent = '0';
                    this.minutesEl.textContent = '0';
                    this.secondsEl.textContent = '0';
                    this.previousValues = { days: '0', hours: '0', minutes: '0', seconds: '0' };
                }

                hideContainer() {
                    const container = document.getElementById('counter-down-container');
                    if (container) {
                        container.style.display = 'none';
                    }
                    clearInterval(this.interval); // 清除定时器
                }

                updateCountdown(force = false) {
                    const now = this.getNewYorkTime();
                    const end = this.endDateObj;
                    let diff = end - now;

                    if (diff <= 0) {
                        this.setAllToZero();
                        this.hideContainer();
                        return;
                    }

                    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

                    // 强制更新或数值变化时更新（解决首次赋值和后续更新问题）
                    if (force || days.toString() !== this.previousValues.days) {
                        this.daysEl.textContent = days.toString();
                        this.previousValues.days = days.toString();
                    }
                    if (force || hours.toString() !== this.previousValues.hours) {
                        this.hoursEl.textContent = hours.toString();
                        this.previousValues.hours = hours.toString();
                    }
                    if (force || minutes.toString() !== this.previousValues.minutes) {
                        this.minutesEl.textContent = minutes.toString();
                        this.previousValues.minutes = minutes.toString();
                    }
                    if (force || seconds.toString() !== this.previousValues.seconds) {
                        this.secondsEl.textContent = seconds.toString();
                        this.previousValues.seconds = seconds.toString();
                    }
                }
            }

            customElements.define('count-down', CountDown);
        }